import React, { Component } from 'react';

class PageEvaluation extends Component {
  render() {
    let selectedValue = '';
    let selectedReason = '';
    let reason = '';

    const rateReason = () => {
      selectedReason = '';
      let rate_reason = document.getElementById('rate_reason');
      const rateStar = document.getElementById('rate_star');
      let negative_reasons = document.getElementById('negative_reasons');
      let positive_reasons = document.getElementById('positive_reasons');

      if (rateStar) {
        const starInputs = rateStar.querySelectorAll("input[name='rate']");
        starInputs.forEach((input) => {
          if (input.checked) {
            selectedValue = input.value;
          }
        });
      }

      rate_reason.removeAttribute('hidden');

      const reason1 = document.querySelectorAll('input[name="reason1"]');
      const reason2 = document.querySelectorAll('input[name="reason2"]');
      reason1.forEach((input) => (input.checked = false));
      reason2.forEach((input) => (input.checked = false));

      if (selectedValue > 3) {
        positive_reasons.removeAttribute('hidden');
        negative_reasons.setAttribute('hidden', '');
      } else {
        negative_reasons.removeAttribute('hidden');
        positive_reasons.setAttribute('hidden', '');
      }
    };

    /**
     * Control to prevent submit
     */
    const formControl = () => {
      let text_error = document.getElementById('text_error');
      let form = document.getElementById('form_rate');
      let negative_reasons = document.getElementById('negative_reasons');
      let positive_reasons = document.getElementById('positive_reasons');

      if (selectedValue > 3) {
        reason = positive_reasons.querySelectorAll("input[name='reason2']");
      } else {
        reason = negative_reasons.querySelectorAll("input[name='reason1']");
      }
      reason.forEach((input) => {
        if (input.checked) {
          selectedReason = input.value;
          text_error.setAttribute('hidden', '');
          negative_reasons.style.cssText +=
            'background-color:transparent;border:0px;padding:0px';
          positive_reasons.style.cssText +=
            'background-color:transparent;border:0px;padding:0px';
          let response = document.getElementById('response');
          response.removeAttribute('hidden');
          form.setAttribute('hidden', '');
        }
      });

      if (!selectedReason) {
        text_error.removeAttribute('hidden');
        negative_reasons.style.cssText +=
          'background-color:#fcb6b3;border:1px solid red;padding:5px';
        positive_reasons.style.cssText +=
          'background-color:#fcb6b3;border:1px solid red;padding:5px';
      }
    };

    /**
     * thanks if form is completed
     */
    const formOk = () => {
      let text_error = document.getElementById('text_error');
      let negative_reasons = document.getElementById('negative_reasons');
      let positive_reasons = document.getElementById('positive_reasons');
      if (selectedValue > 3) {
        reason = positive_reasons.querySelectorAll("input[name='reason2']");
      } else {
        reason = negative_reasons.querySelectorAll("input[name='reason1']");
      }
      reason.forEach((input) => {
        if (input.checked) {
          text_error.setAttribute('hidden', '');
          negative_reasons.style.cssText +=
            'background-color:transparent;border:0px;padding:0px';
          positive_reasons.style.cssText +=
            'background-color:transparent;border:0px;padding:0px';
        }
      });
    };

    return (
      <div
        id="tecnoteca-behavior-pageevaluation"
        className="container bg-primary mt-5 p-4"
      >
        <div className="row justify-content-md-center align-middle">
          {/* <div className="col-xs-1  col-sm-1 col-md-2 col-lg-3">&nbsp;</div> */}
          <div className="col-xs	-10 col-sm-10 col-md-8 col-lg-6 text-left page_evaluation">
            <form id="form_rate" action="">
              <h4 id="reasons_title">
                Quanto sono chiare le informazioni su questa pagina?
              </h4>
              <div className="rate" id="rate_star" required>
                <input
                  type="radio"
                  id="star5"
                  name="rate"
                  value="5"
                  onClick={rateReason}
                />
                <label htmlFor="star5" title="text">
                  {/* 5 stars */}
                </label>
                <input
                  type="radio"
                  id="star4"
                  name="rate"
                  value="4"
                  onClick={rateReason}
                />
                <label htmlFor="star4" title="text">
                  {/* 4 stars */}
                </label>
                <input
                  type="radio"
                  id="star3"
                  name="rate"
                  value="3"
                  onClick={rateReason}
                />
                <label htmlFor="star3" title="text">
                  {/* 3 stars */}
                </label>
                <input
                  type="radio"
                  id="star2"
                  name="rate"
                  value="2"
                  onClick={rateReason}
                />
                <label htmlFor="star2" title="text">
                  {/* 2 stars */}
                </label>
                <input
                  type="radio"
                  id="star1"
                  name="rate"
                  value="1"
                  onClick={rateReason}
                />
                <label htmlFor="star1" title="text">
                  {/* 1 star */}
                </label>
              </div>
              <br></br>
              <div id="rate_reason" className="rate_reason " hidden>
                <div id="reason_choises">
                  <p id="text_error" className="text-danger" hidden>
                    Campo obbligatorio!
                  </p>
                  <div className="rate1 " id="negative_reasons" hidden>
                    <p>
                      Dove hai incontrato le maggiori difficoltà?
                      <b className="text-danger">*</b>
                    </p>
                    <label for="nr-1">
                      <input
                        type="radio"
                        id="nr-1"
                        name="reason1"
                        value="A volte le indicazioni non erano chiare"
                        onClick={formOk}
                      />
                      A volte le indicazioni non erano chiare
                    </label>
                    <hr />
                    <br></br>
                    <label for="nr-2">
                      <input
                        type="radio"
                        id="nr-2"
                        name="reason1"
                        value="A volte le indicazioni non erano complete"
                        onClick={formOk}
                      />
                      A volte le indicazioni non erano complete
                    </label>
                    <hr />
                    <br></br>
                    <label for="nr-3">
                      <input
                        type="radio"
                        id="nr-3"
                        name="reason1"
                        value="A volte non capivo se stavo procedendo correttamente"
                        onClick={formOk}
                      />
                      A volte non capivo se stavo procedendo correttamente
                    </label>
                    <hr />
                    <br></br>
                    <label for="nr-4">
                      <input
                        type="radio"
                        id="nr-4"
                        name="reason1"
                        value="Ho avuto problemi tecnici"
                        onClick={formOk}
                      />
                      Ho avuto problemi tecnici
                    </label>
                    <hr />
                    <br></br>
                    <label for="nr-5">
                      <input
                        type="radio"
                        id="nr-5"
                        name="reason1"
                        value="altro"
                        onClick={formOk}
                      />
                      Altro
                    </label>
                    <hr />
                    <br></br>
                  </div>
                  <div className="rate2 " id="positive_reasons" hidden>
                    <p>
                      Quali sono stati gli aspetti che hai preferito?
                      <b className="text-danger">*</b>
                    </p>
                    <label for="pr-1">
                      <input
                        type="radio"
                        id="pr-1"
                        name="reason2"
                        value="Le indicazioni erano chiare"
                        onClick={formOk}
                      />
                      Le indicazioni erano chiare
                    </label>
                    <hr />
                    <br></br>
                    <label for="pr-2">
                      <input
                        type="radio"
                        id="pr-2"
                        name="reason2"
                        value="Le indicazioni erano complete"
                        onClick={formOk}
                      />
                      Le indicazioni erano complete
                    </label>
                    <hr />
                    <br></br>
                    <label for="pr-3">
                      <input
                        type="radio"
                        id="pr-3"
                        name="reason2"
                        value="Capivo sempre che stavo procedendo correttamente"
                        onClick={formOk}
                      />
                      Capivo sempre che stavo procedendo correttamente
                    </label>
                    <hr />
                    <br></br>
                    <label for="pr-4">
                      <input
                        type="radio"
                        id="pr-4"
                        name="reason2"
                        value="Non ho avuto problemi tecnici"
                        onClick={formOk}
                      />
                      Non ho avuto problemi tecnici
                    </label>
                    <hr />
                    <br></br>
                    <label for="pr-5">
                      <input
                        type="radio"
                        id="pr-5"
                        name="reason2"
                        value="altro"
                        onClick={formOk}
                      />
                      Altro
                    </label>
                    <hr />
                    <br></br>
                  </div>
                </div>
                <div>
                  <textarea
                    id="textArea_comment"
                    rows=""
                    cols=""
                    className=""
                  ></textarea>
                  <button
                    id="send_button"
                    type="button"
                    className="btn btn-primary send_button mt-4"
                    onClick={formControl}
                  >
                    Invia
                  </button>
                </div>
              </div>
            </form>
            <div id="response" hidden>
              <h4 className="color-primary text-center">
                Grazie, il tuo parere ci aiuterà a migliorare il servizio!
              </h4>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PageEvaluation;
